// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"styles_badgeWrapper__DA1kr"};